import styled from "styled-components";
import { useState,useEffect } from "react";
import useWallet from "../../../hooks/Wallet/useWallet";
import useContract from "../../../hooks/useContract";
import {big2num,getFix2} from '../../../utils/utils'
import { FormattedMessage } from "react-intl";
import {getRTPrice} from '../../../api'

export default function Card1() {
  const {myAccount} = useWallet();

  const [rtPrice, setRtPrice] = useState(1);
  const {
    getRBBalance,
    getRBETBalance,
    getUSDTBalance
  } = useContract()
  const [balances, setBalances] = useState({
    RB: 0,
    RBET: 0,
    USDT: 0,
  });
  useEffect(() => {
    loadRTPrice();
  }, []);
  const loadRTPrice = async () => {
    const res = await getRTPrice();
    setRtPrice(res.data);
  };
  useEffect(() => {
    if (myAccount && myAccount.account) {
      getBalances().then((res) => {
        setBalances(res);
      });
    }
  }, [myAccount]);
  const getBalances = async () => {
    let RB = await getRBBalance();
    RB = getFix2(big2num(RB));
    const RBET = await getRBETBalance();
    let USDT = await getUSDTBalance();
    console.log("USDT", USDT,RB);
    const bs = {
      RB,
      RBET,
      USDT,
    };
    return bs;
  };
  return (
    <Wrapper>
      <div className="col">
        <div className="left">
          <img src="image/rb4.png" alt="" />
          <div className="t">RT</div>
        </div>
        <div className="ellipsis">{balances.RB}(${parseFloat(((balances.USDT || 0) * rtPrice).toFixed(4))})</div>
      </div>
      <div className="col">
        <div className="left">
          <img src="image/icons/icon10.png" alt="" />
          <div className="t">USDT</div>
        </div>
        <div className="ellipsis">{parseFloat(Number(balances.USDT || 0).toFixed(4))}(${parseFloat(Number(balances.USDT || 0).toFixed(4))})</div>
      </div>
      <div className="col">
        <div className="left">
          <img src="image/icons/icon11.png" alt="" />
          <div className="t"><FormattedMessage id="装备碎片" /></div>
        </div>
        <div className="ellipsis">{balances.RBET}</div>
      </div>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  background: #3bada4;
  border-radius: 1.0rem;
  padding: .6rem 2.0rem;
  .col {
    padding: .6rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      .t{
        margin-left:1.0rem;
        white-space: nowrap;
        margin-right:1.0rem;
      }
    }
    .ellipsis{
      overflow: hidden;
      text-overflow: ellipsis;
    }
    img {
      width: 2.8rem;
      height: 2.8rem;
    }
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.6rem;

    color: #ffffff;
  }
`;
